<template>
  <div class="root-element">
    <ReportPage v-if="reportmode" ref="reportpage" v-on:reportClosed="onReportModeClose" v-bind:reportPoint="this.mapCenter" v-bind:reportLocation="this.selectedLoc"></ReportPage>

    <div class="map-wrapper" v-bind:class="{ 'mapthin': reportmode}">
      <RankPanel v-show="!reportmode" v-on:weightChange="onWeightChange" v-on:propSelection="onDemographicsChange">loading panel...</RankPanel>

      <DebugPanel v-show="!reportmode" ref="debugpanel">loading panel...</DebugPanel>

      <LocationPanel
        v-on:rem="rem"
        v-show="!reportmode" max-locations="3" ref="locationpanel"
        v-on:locationSelected="flyToLoc"
        v-on:travelshed="travelshed"
        v-on:cleartravelshed="cleartravelshed"
        v-on:reportmodeClicked="onReportMode">loading panel...</LocationPanel>

      <mapbox
        access-token='pk.eyJ1IjoiYnJhbmRvbmJsb29tIiwiYSI6ImNqMzZtMWlyOTAwYXcyd2thcndqdDJ0ZG4ifQ.EHgD2PP0jJaGV_eLt9MMOg'
        ref='mapboxcomponent'
        :map-options="{
          style: 'mapbox://styles/mapbox/streets-v8',
          center: this.mapCenter,
          zoom: 5,
          preserveDrawingBuffer: true
        }"
        :nav-control="{
          show: !reportmode,
          position: 'top-right'
        }"

        @map-load="onLoad"
        @map-dragend="onDrag"
        @map-moveend="onMove"
        @map-zoomend="onZoom"
        @map-click="mapClicked"
        @map-dblclick="mapDoubleClicked"
        @map-sourcedata="mapSourceData" />
    </div>
    <div v-if="reportmode" class="report__footer"><p>
    This information is subject to change. We also encourage you and your advisors to conduct independent investigations to determine the suitability of the property to meet your needs.</p>
      <h2 class="footer__logo text__bauhaus">mDory</h2>
      <p class="text__copyright">&copy; 2019 mdory</p>
    </div>

  </div>
</template>

<script>

import Mapbox from 'mapbox-gl-vue';
import RankPanel from './components/RankPanel.vue';
import ReportPage from './components/ReportPage.vue';
import DebugPanel from './components/DebugPanel.vue';
import LocationPanel from './components/LocationPanel.vue';
import Location from './components/Location.vue';
import * as pinIcon from './components/pinIcon.vue';
import Vue from 'vue';
import PinPopup from './components/PinPopup.vue';
import axios from 'axios';
import swal from 'sweetalert';
import vueDebounce from 'vue-debounce'
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(vueDebounce);

//for polygon intersection
import intersect from '@turf/intersect';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';

// With simple values
//const percentile = require("percentile");
//const pathToRegexp = require("path-to-regexp");

const ISOCHRONE1 = "#da6300";
const ISOCHRONE2 = "#11DD66";

export default {
  name: 'app',
  components: {
    Mapbox,
    RankPanel,
    LocationPanel,
    ReportPage,
    DebugPanel
  },
  mounted: function() {
    let mapDiv = window.map;
    this.$nextTick(function () {
        mapDiv.style.height='100%';
    });

    //check the URL for #report
    if (window.location.hash.substr(0,7) == '#report') {
        this.reportmode = true;

		try {
        this.reportparams =  JSON.parse( atob( window.location.hash.substr(8) ) );

		} catch (e) {
		//can't docode passed js
        console.log(e);
		}
    } else {
        this.reportmode = false;
    }
  },
  data: function() {
      return {
       'mapCenter': [-83.05730, 39.923748],
       'reportmode': true,
       'reportparams': {},
       'weights': {
           'pct_dev': 100,
           'hh_inc': 100,
           'ap_dist': 100,
           'hh': 100,
           'pop':100,
        },
        'demographics': [
        ],
        'clickEvent': null,
        'redrawRequest': null,
        temploc:{},
        selectedLoc:null,
        allIsochrones: {},
        'mapPinGeoJson': {
          "type": "FeatureCollection",
          "features": [
          /*{
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [-88, 42.8]
            }
          }*/
          ]
        }
      }
  },
  methods: {
    rem(e)
    {
        console.log("top removeLocation");
        console.log(e);
    },

    onLoad(map) {

      map.resize();

      map.addSource("valhalla", {
        "type": "geojson",
        "data": {
            "type": "FeatureCollection",
            "features": []
        }
      });

      var self = this;
      map.loadImage("/map-pin.png", function (error, image) {
        if (error) throw error;
        map.addImage('custom-marker', image);
        map.addSource('mappin-source', {
          "cluster": true,
          "type": "geojson",
          "data": self.mapPinGeoJson
        });

        map.addLayer({
            "id": "markers",
            "type": "symbol",
            "source":  'mappin-source',
             filter: ["!", ["has", "point_count"]],
            "layout" : {
              "icon-image": "custom-marker"
            }
        });
        map.addLayer({
            "id": "markers-clustered",
            "type": "circle",
            "source":  'mappin-source',
            "filter": ["has", "point_count"],
            "paint": {
              "circle-color": [
                "step",
                ["get", "point_count"],
                "#51bbd6",
                5,
                "#f1f075",
                9,
                "#f28cb1"
              ],
              "circle-radius": [
                "step",
                ["get", "point_count"],
                20,
                5,
                30,
                9,
                20
              ]
            }
        });
        map.addLayer({
            "id": "markers-clustered-count",
            "type": "symbol",
            "source":  'mappin-source',
            "filter": ["has", "point_count"],
            "layout": {
              "text-field": "{point_count}",
            }
        });
      });


      var layers = map.getStyle().layers;
      // Find the index of the first symbol layer in the map style
      var firstSymbolId;
      for (var i = 0; i < layers.length; i++) {
        if (layers[i].type === 'symbol') {
          firstSymbolId = layers[i].id;
          break;
        }
      }
      firstSymbolId = 'water';


      map.addSource("us-counties-vector", {
        "name": "us-counties-vector",
        "type": "vector",
        "tiles": [process.env.VUE_APP_TILE_BASE_URI + "/county/{z}/{x}/{y}.pbf"],
        //"tiles": ["http://mdory-sandbox:9990/maps/mdory/{z}/{x}/{y}.vector.pbf"],
        "maxzoom": 9,
      });
      map.addSource("us-tracts-vector", {
        "name": "us-counties-vector",
        "type": "vector",
        "tiles": [process.env.VUE_APP_TILE_BASE_URI + "/tract/{z}/{x}/{y}.pbf"],
        //"tiles": ["http://mdory-sandbox:9990/maps/mdory/{z}/{x}/{y}.vector.pbf"],
        "maxzoom": 11,
      });

      var fillColor = [
        'match',
        ['number', ['feature-state', 'rank'], 10],
        10, '#FFFFD9',
        20, '#EDF8B1',
        30, '#C7E9B4',
        40, '#7FCDBB',
        50, '#41B6C4',
        60, '#1D91C0',
        70, '#225EA8',
        80, '#253494',
        90, '#081d58',
        '#FFFFD9',
      ];

     map.addLayer({
        "id": "us-counties-dyn",
        "type": "fill",
        "source": "us-counties-vector",
        "source-layer": "geojsonlayer",
        "minzoom": 1,
        "maxzoom": 9,
        "paint": {
            //'fill-color':'#FFFFD9',
            'fill-color':fillColor,
            "fill-opacity": 0.65
        }
      }, firstSymbolId);
     map.addLayer({
        "id": "us-tracts-dyn",
        "type": "fill",
        "source": "us-tracts-vector",
        "source-layer": "us_tracts",
        "minzoom": 9,
        "maxzoom": 22,
        "paint": {
            //'fill-color':'#FFFFD9',
            'fill-color':fillColor,
            "fill-opacity": 0.65
        }
      }, firstSymbolId);

      map.addLayer({
        "id": "driving-distance-stroke",
        "type": "line",

        "source": "valhalla",
        "paint": {
            "line-width": 2,
            "line-color": ['get', 'stroke'],
            "line-opacity": 0.80,
        },
        "filter": ["==", "$type", "Polygon"]
      });


      map.addLayer({
        "id": "driving-distance",
        "type": "fill",

        "source": "valhalla",
        "paint": {
            "fill-color": ['get', 'fillColor'],
            "fill-opacity": 0.3,
        },
        "filter": ["==", "$type", "Polygon"]
      });

      if (this.reportmode && typeof this.reportparams.lon !== 'undefined') {
        this.mapCenter = [ this.reportparams.lon, this.reportparams.lat];
        var l = Vue.extend(Location);
        let locobj = new l({data: {
            lat: this.reportparams.lat,
            lon: this.reportparams.lon,
        }});

        this.flyToLoc(locobj);
      }
    },
    onDrag() {
        //since score is based on what's in the viewport,
        //we will stop updating the location's score on drag.
        //onMove is okay, because we're probably zooming away and
        //selecting a new selectedLoc
        if (this.selectedLoc) {
            this.selectedLoc.scoreUpdate = false;
        }
    },
    onMove() {
        this.recalcAndDraw();
    },
    onZoom() {
        this.recalcAndDraw();
    },
    onDemographicsChange(listOfDemo) {
        this.demographics = listOfDemo;
    },
    onWeightChange(attrName,value) {
        //speed up rendering when lots of weights change
        //at the same time by queueing up the  recalc + repaint
        this.weights[attrName] = value;

        this.recalcAndDraw();
    },
    recalcAndDraw() {
        try {
            var self = this;

            if (this.redrawRequest != null) {
                window.clearTimeout(this.redrawRequest);
            }
            this.redrawRequest = window.setTimeout(function () { self.recalcRanks(self.$refs.mapboxcomponent._map); self.$refs.mapboxcomponent._map.triggerRepaint(); this.redrawRequest = null;}, 400);
        } catch (e) {
            this.syncRecalc = false;
            window.clearTimeout(this.redrawRequest);
            this.redrawRequest = null;
        }
    },
    mapSourceData(map) {
      //called after a source has finished loading
      //a tile
      this.recalcAndDraw();
      //docs say you'll get one last event
      //where the map is loaded, bu this doesn't happen
      if (!map.loaded()) {
        return;
      } else {
        //this will never happen :(
        //alert("got source loaded and map is also loaded");
        // eslint-disable-next-line
        console.log("We got an event which we're supposed to get, hooray");
        this.recalcAndDraw();
      }
    },
    mapDoubleClicked() {
      if (this.clickEvent != null) {
        window.clearTimeout(this.clickEvent);
      }
      this.clickEvent = null;
    },
    mapClicked(map, e) {
      //debounce double clicks
      let self = this;
      if (this.clickEvent != null) {
        window.clearTimeout(this.clickEvent);
        this.clickEvent = window.setTimeout(function () { self.handleClick(map, e); }, 300);
      } else {
        this.clickEvent = window.setTimeout(function () { self.handleClick(map, e); }, 300);
      }

    },
	onReportModeClose() {
		window.location.hash = "";
		this.reportmode = false;

        let self =this;
        window.setTimeout(function () { self.$refs.mapboxcomponent._map.resize() }, 600);
	},
	onReportMode(loc) {
		window.location.hash = "#report/" + btoa(JSON.stringify( {'lon': loc.lon, 'lat':loc.lat} ));
		this.reportmode = true;

        let self =this;
        window.setTimeout(function () { self.$refs.mapboxcomponent._map.resize() }, 600);
	},
    cleartravelshed(params)
    {
        let self = this;
        let loc = params.loc;
        this.clearDriveTime(loc);
        self.clearDriveTime(loc);
    },
    travelshed(params) {
      let loc = params.loc;
      let traveltime = loc.traveltime;
      let contours = [{"time":10},{"time":20}];

      if(traveltime==2)
      {
        contours = [{"time":15},{"time":30}];
      }
        let myZoom = this.$refs.mapboxcomponent._map.getZoom();
        if (myZoom < 9) myZoom = 9;

        //keep mapCenter in sync because it is fed to ReportPage
        this.mapCenter = [ loc.lat, loc.lon ];
        // this.clearDriveTime();
        this.$refs.mapboxcomponent._map.flyTo({ center: [loc.lat, loc.lon], zoom: myZoom });
        this.addDriveTime(loc.lat, loc.lon, loc);
    },
    flyToLoc(loc) {
        this.selectedLoc = loc;
        let myZoom = this.$refs.mapboxcomponent._map.getZoom();
        if (myZoom < 9) myZoom = 9.3;
        //keep mapCenter in sync because it is fed to ReportPage
        this.mapCenter = [ loc.lat, loc.lon ];
        // this.clearDriveTime();
        this.$refs.mapboxcomponent._map.flyTo({ center: [loc.lat, loc.lon], zoom: myZoom });
        this.addDriveTime(loc.lat, loc.lon, loc);
    },
    flyToLocNoDrive(loc) {
        let myZoom = this.$refs.mapboxcomponent._map.getZoom();
        if (myZoom < 9) myZoom = 9;
        // this.clearDriveTime();
        this.$refs.mapboxcomponent._map.flyTo({ center: [loc.lat, loc.lon], zoom: myZoom });
    },
    /**
     * moved all the triggers to location panel
     * @deprecated
     * @param marker
     */
    clickedMarker(marker)
    {
        let self = this;
        console.log("clicked marker");
        console.log(marker);
        let foundLocations = self.$refs.locationpanel.locations.filter( (f) => {
            console.log(f.id);
            console.log(marker.properties.id);
                if(f.id==marker.properties.id)
                {
                    return f;
                }
        });
        console.log("found");
        console.log(foundLocations);

        if(foundLocations)
        {
            foundLocations[0].edit();
        }

    },
    handleClick(map, e) {
      console.log("HANDLECLICK");
       let clickFeature = map.queryRenderedFeatures(e.point);
       var debugHtml, popupHtml = '';
       let self = this;
       var clickedFeature;
       var clickedMarker = false;
       clickFeature.map( item => {
           if (item.layer.id == "us-tracts-dyn" || item.layer.id == "us-counties-dyn") {
             clickedFeature = item;
           }
// if we want to allow the pin to be clicked...
//            if(item.layer.id=="markers")
//            {
//               clickedMarker = item;
//            }
       });
       // if(clickedMarker!=false)
       // {
       //    this.clickedMarker(clickedMarker);
       //    return false;
       // }
       if (clickedFeature != undefined) {
           // eslint-disable-next-line
           console.log(clickedFeature);
           debugHtml  = '<div class="feature-detail">';
           debugHtml += '<h4>'+clickedFeature.properties['NAME']+'</h4>';
           debugHtml += '<h4>FIPS: '+clickedFeature.id+' lng: ' + e.lngLat.lng +' lat: '+e.lngLat.lat+'</h4>';
           debugHtml += '<table width="100%">';
           debugHtml += '<tr><th>Min</th><th>Val</th><th>Max</th><th>Rank</th></tr>';
           self.demographics.forEach( demographic => {
             debugHtml += '<tr><td>'+demographic.attr+'-min: '+ clickedFeature.state[demographic.attr+"-min"] +'</td>';
             debugHtml += '<td>'+demographic.attr+': '+ clickedFeature.properties[demographic.attr] +'</td>';
             debugHtml += '<td>'+demographic.attr+'-max: '+ clickedFeature.state[demographic.attr+"-max"] +'</td>';
             debugHtml += '<td>'+demographic.attr+'-rank: '+ clickedFeature.state['rank'+demographic.attr].toFixed(2) +'</td></tr>';
           });
           debugHtml += '</table>';

           debugHtml += '<ul>';
           debugHtml += '<li>Rank: '+ clickedFeature.state['rank'] +'</li>';
           debugHtml += '<li>Score: '+ clickedFeature.state['score'] +'</li>';
           debugHtml += '<li>ScoreMax: '+ clickedFeature.state['score-max'] +'</li>';
           debugHtml += '<li>ScoreRaw: '+ clickedFeature.state['score-raw'] +'</li>';
           debugHtml += '<li>ScoreMin: '+ clickedFeature.state['score-min'] +'</li>';
           debugHtml += '</ul></div>';

           if (this.$refs['debugpanel'])
           this.$refs['debugpanel'].setHtml(debugHtml);

           popupHtml += '<h3>Drop pin here?</h3>';
           //popupHtml += '<p><b>'+clickedFeature.properties['NAME']+'</b></p>';
           popupHtml += '<button id="mappin-btn-vue" class="btn-mappin" data-lnglat="'+e.lngLat.lat+','+e.lngLat.lng+'"><img src="data:image/svg+xml;base64,'+pinIcon.svgSource+'"></button>';

           var popup = new mapboxgl.Popup({closeOnClick: true})
               .setLngLat(e.lngLat)
               .setHTML(popupHtml)
               .addTo(map);

           var popupContent = Vue.extend(PinPopup);
           var instance =  new popupContent({
               propsData: { clickedPoint: [e.lngLat.lng, e.lngLat.lat, clickedFeature] }
           });

           instance.$mount('#mappin-btn-vue');
           instance.$on('newPoint', function(point) {
             let addLocation = self.$refs.locationpanel.addLocation(point);
             instance.$destroy();
             popup.remove();
           });
         }
    },
    clearDriveTime(loc) {
      let self = this;
      console.log("CLEARING");
      self.allIsochrones[loc.id] = {};
      self.renderIsochrones();
      // this.$refs.mapboxcomponent._map.getSource('valhalla').setData({});
      console.log("CLEARED");
      return true;
    },
    addDriveTime(lon, lat, loc) {
      let self = this;
      let contours = [{"time":10},{"time":20}];
      if(loc!=undefined && loc.traveltime==2)
      {
        contours = [{"time":15},{"time":30}];
      }
      var url = process.env.VUE_APP_ROUTE_BASE_URI+'/isochrone?json=';
      var json = {
        locations: [{"lat":lat, "lon":lon}],
        costing: "auto",
        contours: contours,
        polygons: true,
        denoise: .2,
        generalize: 150
      };
      url += escape(JSON.stringify(json));
      //grab the url
      self.temploc = loc;
      axios['get'](url)
      .then(function(response){
          let isochrones = response.data;
          isochrones.features[0].properties.color = ISOCHRONE1;
          isochrones.features[0].properties.stroke = '#666666';
          isochrones.features[0].properties.fill = ISOCHRONE1;
          isochrones.features[0].properties.fillColor = ISOCHRONE1;
          isochrones.features[1].properties.color = ISOCHRONE2;
          isochrones.features[1].properties.stroke = '#666666';
          isochrones.features[1].properties.fill = ISOCHRONE2;
          isochrones.features[1].properties.fillColor = ISOCHRONE2;
          self.temploc.isochrones = isochrones;

          let id = self.temploc.id;
          self.allIsochrones[id] = isochrones;

          self.renderIsochrones();

      }.bind(self));
    },
    renderIsochrones() {
      let self = this;
      // get all features from all isochones
      let all = {features: [], type: "FeatureCollection"};
      let keys = Object.keys(self.allIsochrones);
      keys.forEach(function (f) {
        if (self.allIsochrones[f].features) {
          self.allIsochrones[f].features.forEach(function (j) {
            all.features.push(j);
          });
        }
      });
      self.$refs.mapboxcomponent._map.getSource('valhalla').setData(all);
      this.$refs.mapboxcomponent._map.triggerRepaint();

       var isoscore0 = 0;
       var isocount0 = 0;
       var isoscore1 = 0;
       var isocount1 = 0;
       let mapLayer = 'us-tracts-dyn';
       let srcName = 'us-tracts-vector';
       let layerName = 'us_tracts';

       let features = self.$refs.mapboxcomponent._map.queryRenderedFeatures({layers:[mapLayer]});
       //float the score on the selected location
       if (typeof(self.selectedLoc)!='undefined' && self.selectedLoc.scoreUpdate)  {
         let selLoc = self.selectedLoc;
         features.forEach( (feat) => {
         /*
           if (selLoc.geoid == feat.id) {
             let fstate = feat.state;
             if (!fstate) return;
             selLoc.score = fstate['score'];
           }
           */
           if (selLoc.isochrones.features  &&  selLoc.isochrones.features.length) {
           //calculate avg/mean score within 2 driving distances
           if (intersect(feat.geometry, selLoc.isochrones.features[0].geometry)) {
             isoscore0 += feat.state['score'];
             isocount0++;
           }

           if (intersect(feat.geometry, selLoc.isochrones.features[1].geometry)) {
             isoscore1 += feat.state['score'];
             isocount1++;
           }
           }
         });
         if (isocount0 > 0) {
             self.selectedLoc.isozeroscore = isoscore0/isocount0;
             self.selectedLoc.isoonescore  = isoscore1/isocount1;
         }
       }
    },
    recalcRanks(map) {
       if (this.syncRecalc) {
         return;
       }
       this.syncRecalc = true;

       let myZoom = map.getZoom();
       var mapLayer  = 'us-counties-dyn';
       var srcName   = 'us-counties-vector';
       var layerName = 'geojsonlayer';
       if (myZoom >=9) {
           mapLayer = 'us-tracts-dyn';
           srcName = 'us-tracts-vector';
           layerName = 'us_tracts';
       }
       //gets only features visible in the viewport
       let features = map.queryRenderedFeatures({layers:[mapLayer]});
       /*
       //this gets all features from all tiles that are in the viewport (including features not in the viewport
       but that are on a tile in the viewport)
       let features = map.querySourceFeatures('us-counties-vector', {
          'sourceLayer': 'geojsonlayer'
       });
       */

       this.demographics.forEach( (demographic) => {
            if (!demographic.inverse)
            this.normalizeProperty( demographic.attr, features, map, srcName, layerName);
       });

       this.demographics.forEach( (demographic) => {
            if (demographic.inverse)
            this.normalizePropertyNeg( demographic.attr, features, map, srcName, layerName);
       });


       features = map.queryRenderedFeatures({layers:[mapLayer]});
       this.demographics.forEach( (demographic) => {
            this.weightRank( demographic.attr, this.weights[demographic.attr], features, map, srcName, layerName);
       });

       //normalize ranks
       features = map.queryRenderedFeatures({layers:[mapLayer]});
       this.normalizeRank( this.demographics, features, map, srcName, layerName);

       //if selected location came from geocoder, then it doesn't
       //have a matching GEOID fro any map feature from county or tract layer
       //let's fix that here.
       //we only have 1 geoid, let's save it for tract level stuff
       //eventually the selectedLoc should have 2 geo ids
       if (mapLayer == 'us-tracts-dyn') {
           this.selectedLoc = this.updateSelectedLocGeoId(this.selectedLoc, features);
       }

       var isoscore0 = 0;
       var isocount0 = 0;
       var isoscore1 = 0;
       var isocount1 = 0;
       //gotta keep querying because of updating fstate and gl memory and other stuff
       features = map.queryRenderedFeatures({layers:[mapLayer]});
       //float the score on the selected location
       if (this.selectedLoc && this.selectedLoc.scoreUpdate)  {
         let selLoc = this.selectedLoc;
         features.forEach( (feat) => {
           if (selLoc.geoid == feat.id) {
             let fstate = feat.state;
             if (!fstate) return;
             selLoc.score = fstate['score'];
           }
           if (selLoc.isochrones.features && selLoc.isochrones.features.length) {
           //calculate avg/mean score within 2 driving distances
           if (intersect(feat.geometry, selLoc.isochrones.features[0].geometry)) {
             isoscore0 += feat.state['score'];
             isocount0++;
           }

           if (intersect(feat.geometry, selLoc.isochrones.features[1].geometry)) {
             isoscore1 += feat.state['score'];
             isocount1++;
           }
           }
         });
         if (isocount0 > 0) {
             this.selectedLoc.isozeroscore = isoscore0/isocount0;
             this.selectedLoc.isoonescore  = isoscore1/isocount1;
         }
       }
       //average ranks
//       features = map.queryRenderedFeatures({layers:[mapLayer]});
//       this.averageRanks(features, demographics,  map, srcName, layerName);

      this.syncRecalc = false;
    },
    updateSelectedLocGeoId(selectedLoc, featureList) {
        if (!selectedLoc || selectedLoc === null) {
            return;
        }
        if (selectedLoc.geoid != 0) {
            return selectedLoc;
        }
        featureList.forEach( (feat) => {
            if (booleanPointInPolygon(selectedLoc.point.geometry.coordinates, feat.geometry)) {
                selectedLoc.geoid = feat.id;
                return;
            }
        });
        return selectedLoc;
    },
    /*
    averageRanks(features, demographics, map, srcName, layerName) {
       var maxRank = 0;
       features.forEach( (feat) =>  {

           var rank  = 0;
           let score = 0;
           demographics.forEach( (demographic) => {
              let fstate = feat.state;
              if (!fstate) return;
              score += fstate['rank'+demographic.attr];
           });
           score /= demographics.length;
           if (rank > maxRank) maxRank = rank;

           rank = (Math.floor( score/10 )) * 10;
           if (rank < 10) rank=10;
           if (rank > 90) rank=90;
           map.setFeatureState( {
             source: srcName,
             sourceLayer: layerName,
             id: feat.id
           } , {
             "rank":rank,
             "score":score,
           });
       });
    },
    */
    normalizeRank: function(demographics, features, map, srcName, layerName) {
      var min = -1;
      var max = 0;
      features.forEach( (feat) => {
        let score = 0;
        demographics.forEach( (demographic) => {
          let fstate = feat.state;
          if (!fstate) return;
          if (!isNaN(fstate['rank'+demographic.attr])) {
            score += fstate['rank'+demographic.attr]
          }
        });

        if (score > max) max = score;
        if (!isNaN(score) && (min > score  || min==-1)) {
          min = score;
        }

      });
      if (isNaN(min)) {
        min =0;
      }


      features.forEach( (feat) => {
        var rank  = 0;
        let score = 0;
        demographics.forEach( (demographic) => {
          let fstate = feat.state;
          if (!fstate) return;

          if (!isNaN(fstate['rank'+demographic.attr])) {
            score += fstate['rank'+demographic.attr]
          }
        });

        let rawscore = score;
        if (score < min) { score = 0;}
        else {
        score = (score - min) / (max-min)*100;
        }

        rank = (Math.floor( score/10 )) * 10;
        if (rank < 10) rank=10;
        if (rank > 90) rank=90;

        let fstate = {'rank': rank, 'score': score, 'score-raw': rawscore, 'score-max': max, 'score-min':min};
        map.setFeatureState( {
          source: srcName,
          sourceLayer: layerName,
          id: feat.id
        } , fstate);
      });
    },
    normalizeProperty: function(attrName, features, map, srcName, layerName) {
      var min = -1;
      var max = 0;
      features.forEach( (feat) => {
        let fval = parseFloat(feat.properties[attrName]);
        if (isNaN(fval)) fval = parseInt(feat.properties[attrName]);
        if (max < fval) {
          max = fval;
        }
        if (!isNaN(fval) && (min > fval || min==-1)) {
          min = fval;
        }
      });
      if (isNaN(min)) {
        min =0;
      }


      var rankAttrName = "rank"+attrName;
      features.forEach( (feat) => {
        let fval = parseFloat(feat.properties[attrName]);
        if (isNaN(fval)) fval = parseInt(feat.properties[attrName]);
        if (fval < min) { fval = 0; }
        else {
        fval = (fval - min) / (max-min);
        }
        let fstate = {};
        fstate[rankAttrName] = fval*100;
        fstate[attrName+"-max"] = max;
        fstate[attrName+"-min"] = min;
        map.setFeatureState( {
          source: srcName,
          sourceLayer: layerName,
          id: feat.id
        } , fstate);

      });
    },

    normalizePropertyNeg: function(attrName, features, map, srcName, layerName) {
      var min = -1;
      var max = 0;
      features.forEach( (feat) => {
        let fval = parseFloat(feat.properties[attrName]);
        if (isNaN(fval)) fval = parseInt(feat.properties[attrName]);
        fval *= -1;
        if (max < fval) {
          max = fval;
        }
        if (!isNaN(fval) && (min > fval || min==-1)) {
          min = fval;
        }
      });
      if (isNaN(min)) {
        min =0;
      }


      var rankAttrName = "rank"+attrName;
      features.forEach( (feat) => {
        let fval = parseFloat(feat.properties[attrName]);
        if (isNaN(fval)) fval = parseInt(feat.properties[attrName]);
        fval *= -1;
        if (fval < min) { fval = -1; }
        else {
        fval = (fval - min) / (max-min);
        }
        let fstate = {};
        fstate[rankAttrName] = fval*100;
        fstate[attrName+"-max"] = max;
        fstate[attrName+"-min"] = min;
        map.setFeatureState( {
          source: srcName,
          sourceLayer: layerName,
          id: feat.id
        } , fstate);

      });
    },

    weightRank: function(attrName, weight, features, map, srcName, layerName) {

      var rankAttrName = "rank"+attrName;
      features.forEach( (feat) => {
        let fstate = feat.state;
        if (!fstate) return;

        fstate[rankAttrName] *= (weight/100);
        map.setFeatureState( {
          source: srcName,
          sourceLayer: layerName,
          id: feat.id
        } , fstate);
      });
    }
  }
}
</script>

<style lang="scss">
  $theme-colors: (
    primary: #1d91c0,
    secondary: #253494,
    light: #f0f8ff,
    info: #41b6c4,
    danger: rgb(210, 49, 41)
  );

  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/src/index.scss';

  body {
  margin:0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin:0.25em;
  /*  margin-top: 60px; */
  }
  #map {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
  }

  #map canvas.mapboxgl-canvas {

  }
  .feature-detail ul {
    list-style:none;
    margin-left:0;
    padding-left:0;

  }
  .feature-detail h4 {
  margin-top:0.5em;
  margin-bottom:0.2em;
  }
  .mapboxgl-popup p {
    margin-top:0.2em;
    margin-bottom:0.2em;
  }
  @media print {
  .mapboxgl-control-container {
      display:none;
  }
  }
  .mapthin  #map.mapboxgl-map {
  /* 96 dpi x 8.5 inch */
      width:816pt !important;
      height:816pt !important;
      margin:auto;
      position:relative;
  }

  .card {
    background-color: rgba(232, 244, 255, .95);
    border: 0;
    box-shadow: 0 .125rem .25rem rgba(black, .2);
    position: fixed;
    z-index: 50;
  }

  .panel__title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  [class*="btn-outline"] {
    background-color: rgba(white, (2/3));
  }

  .btn-group {
    &.spaced {
      .btn + .btn {
        margin-left: 1px;
      }
    }
  }
  .report__footer {
    text-align:center;
    width:100%;
    margin-top:2em;
  }
  .text__copyright {
    font-size:75%;
  }
  .footer__logo {
    font-family: 'Bauhaus93';
  }
</style>
